import { render, staticRenderFns } from "./middlePage.vue?vue&type=template&id=0f583d62&scoped=true"
import script from "./middlePage.vue?vue&type=script&lang=js"
export * from "./middlePage.vue?vue&type=script&lang=js"
import style0 from "./middlePage.vue?vue&type=style&index=0&id=0f583d62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f583d62",
  null
  
)

export default component.exports